import { useQuery } from '@tanstack/react-query';
import ProductCategoryService, { CHAVES_CATEGORIAS_PRODUTO } from '../api/ProductCategoryService';

/**
 * Catálogo de categorias do sistema. Chave única compartilhada pela biblioteca
 * de produtos, pelo editor de rotina e pelo modal de sugestão da IA — uma
 * requisição serve as três telas.
 */
export default function useProductCategories() {
  const query = useQuery({
    queryKey: CHAVES_CATEGORIAS_PRODUTO.todas,
    queryFn: async () => (await ProductCategoryService.getAll()).data ?? [],
    // Catálogo global e imutável durante a sessão: não vale revalidar a cada minuto.
    staleTime: Infinity,
  });

  return {
    categories: query.data ?? [],
    loading: query.isPending,
    error: query.isError ? 'Não foi possível carregar as categorias.' : '',
  };
}
